<template>
  <q-input
    ref="input"
    :model-value="modelValue"
    :placeholder="placeholder"
    input-class="text-caption"
    dense
    outlined
    class="col"
    @update:model-value="$emit('update:modelValue', $event)"
    @keyup.escape.stop="close"
  >
    <template v-slot:append>
      <q-icon
        v-if="modelValue"
        name="fa fa-times"
        size="xs"
        class="cursor-pointer"
        @click="clear"
      />
      <q-icon
        v-else
        name="fa fa-search"
        size="xs"
      />
    </template>
  </q-input>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['close', 'update:modelValue'],
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Search...',
    },
  },
  methods: {
    clear() {
      this.$emit('update:modelValue', '');
    },
    close() {
      this.$emit('update:modelValue', '');
      this.$emit('close');
    },
    focus() {
      (this.$refs.input as any).focus();
    },
  },
});
</script>
